import React from 'react'
import { Button } from '@mui/material'

const NotFound = () => {
	return (
		<div>
			<h2>
				404 Not found
			</h2>
			<Button variant="contained" href="dashboard">Dashboard</Button>
		</div>
	)
}

export default NotFound